import { gadgetsWarehouseQueryKey } from './index'

const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.GADGETS_WAREHOUSES)
const groupWarehouseStatusPrefix = createApiRoute(
	ApiModule.ORDER,
	ApiAuthorization.EMPLOYEE,
	ApiDataModel.GADGETS_WAREHOUSE_STATUSES,
)

export const apiGadgetsWarehouse = {
	fetchGadgetsWarehousesFilter: async (): Promise<IGadgetsWarehouseFilterModel[]> => {
		const fetchFn = async (): Promise<IGadgetsWarehouseFilterModel[]> => {
			const { data } = await apiCommon<IGadgetsWarehouseFilter[]>(
				`${groupWarehouseStatusPrefix}/filter-warehouses`,
				{
					method: 'GET',
				},
			)

			return data.map(GadgetsWarehouseFilter)
		}

		const config = () => ({
			queryKey: gadgetsWarehouseQueryKey.list(),
			queryFn: async () => await fetchFn(),
		})

		return await useQueryClientService().fetchQuery<IGadgetsWarehouseFilterModel[]>(config)
	},
	fetchGadgetsWarehouses: async (
		search: IApiSearch = { query: '' },
		pagination: IApiPagination = { page: 1, perPage: 25 },
		filters?: IApiFilters,
		sorting?: ISortingOption,
	): Promise<IApiResponseModel<IGadgetsWarehouseModel[]>> => {
		const fetchFn = async (): Promise<IApiResponseModel<IGadgetsWarehouseModel[]>> => {
			const searchFilter = createSearchQuery(search.query, search.type)

			const { data, meta } = await apiCommon<IGadgetsWarehouse[]>(`${groupPrefix}`, {
				method: 'GET',
				...createQuery(
					pagination,
					{ ...filters, ...searchFilter },
					sorting ? { [sorting.key]: sorting.type } : undefined,
				),
			})

			return { data: data.map(GadgetsWarehouse), meta }
		}

		const config = () => ({
			queryKey: gadgetsWarehouseQueryKey.list({ search, pagination, filters, sorting }),
			queryFn: async () => await fetchFn(),
		})

		return await useQueryClientService().fetchQuery<IApiResponseModel<IGadgetsWarehouseModel[]>>(config)
	},
	fetchGadgetsWarehouseDetails: async (id: number): Promise<IGadgetsWarehouseModel> => {
		const { data } = await apiCommon<IGadgetsWarehouse>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return GadgetsWarehouse(data)
	},
	createGadgetsWarehouse: async (payload: IGadgetsWarehouseCreatePayload): Promise<IGadgetsWarehouseModel> => {
		const { data } = await apiCommon<IGadgetsWarehouse>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		useQueryClientService().invalidateQueries(gadgetsWarehouseQueryKey.lists())

		return GadgetsWarehouse(data)
	},
	updateGadgetsWarehouse: async (payload: IGadgetsWarehouseUpdatePayload): Promise<IGadgetsWarehouseModel> => {
		const { data } = await apiCommon<IGadgetsWarehouse>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		useQueryClientService().invalidateQueries(gadgetsWarehouseQueryKey.lists())

		return GadgetsWarehouse(data)
	},
	deleteGadgetsWarehouse: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, {
			method: 'DELETE',
		})

		useQueryClientService().invalidateQueries(gadgetsWarehouseQueryKey.lists())
	},
}
